// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';
import type { TrendinessType } from '../../../../../types/apolloType';

type Props = {
  trendiness: TrendinessType,
};

type State = {
  scaleGrowth: Scale[],
  scaleAwareness: Scale[],
};

type Scale = {
  note: number,
  range: string,
}

class TrendinessComponent extends React.Component<Props, State> {
  state = {
    scaleGrowth: [
      { note: 10, range: '30%' },
      { note: 9, range: '30%' },
      { note: 8, range: '10%' },
      { note: 7, range: '5%' },
      { note: 6, range: '-5%' },
      { note: 5, range: '-15%' },
      { note: 4, range: '-20%' },
      { note: 3, range: '-25%' },
      { note: 2, range: '-30%' },
      { note: 1, range: '-40%' },
      { note: 0, range: '' }
    ],
    scaleAwareness: [
      { note: 10, range: '1' },
      { note: 8, range: '2' },
      { note: 6, range: '3' },
      { note: 4, range: '4' },
      { note: 2, range: '5' },
      { note: 0, range: '6+' }
    ],
  }

  render() {
    const TRENDINESS_YEAR = 2020;
    return (
      <div className="scarcity">
        <div className="scarcity-standard">
          <p className="scarcity-title">
            {I18n.t('attractiveScore.trendiness.growth', { year: TRENDINESS_YEAR})}
          </p>
          {
            this.state.scaleGrowth.map((growth) => (
              <div className="scale-container">
                <div className={`note ${this.props.trendiness.brandGrowthEuNote === growth.note ? ' active' : ''}`}>
                  {growth.note}
                </div>
                { growth.range !== '' && <div className="lign" /> }
                <span className="range">{growth.range}</span>
              </div>
            ))
          }
        </div>

        <div className="scarcity-standard">
          <p className="scarcity-title">{I18n.t('attractiveScore.trendiness.awareness')}</p>
          {
            this.state.scaleAwareness.map((awareness) => (
              <div className="scale-container">
                <div className={`note ${awareness.note === 0 ? '' : 'note-bigger'} ${this.props.trendiness.brandAwarenessNote === awareness.note ? 'active' : ''}`}>
                  {awareness.note}
                </div>
                {
                  awareness.range !== '' &&
                    <div className={`lign ${awareness.note === 0 ? 'lign-smaller' : 'lign-bigger'}`} />
                }
                <span className={`range ${awareness.note === 0 ? 'range-smaller' : 'range-bigger'}`}>
                  {awareness.range}
                </span>
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

export default TrendinessComponent;
